import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ss-input',
    templateUrl: './ss.input.component.html',
    styleUrls: ['./ss.input.component.scss']
})
export class SSInputComponent implements OnInit {

    @Input('Label') Label: string;
    @Input('Type') Type: string;
    @Input('Placeholder') Placeholder: string;
    @Input('Tooltip') Tooltip: string;
    @Input('InputClass') InputClass: string;
    @Input('CanClear') CanClear: boolean;
    @Input('Options') Options: Array<any>;

    @Input('Value') Value : any = '';
	@Output() ValueChange : EventEmitter<any> = new EventEmitter<any>();

    @Input('ButtonLabel') ButtonLabel: string;
    @Input('ButtonIcon') ButtonIcon: string;
    @Input('ButtonClass') ButtonType: string;

    @Output('onValueChanged') onValueChanged: EventEmitter<any> = new EventEmitter();
    @Output('onButtonClicked') onButtonClicked: EventEmitter<string> = new EventEmitter();

    SelectedOptions: Array<any> = [];

    constructor() { }

    ngOnInit() {
        //console.log("Model: ", this.Model);
    }

    ValueChanged() {
        //console.log(this.Model);
		this.onValueChanged.emit(this.Value);
		this.ValueChange.emit(this.Value);	
    }

    ButtonClick() {
        this.onButtonClicked.emit(this.Value);
    }

    ClearInput() {
        this.Value = '';
        this.ButtonClick();
    }

    SelectOption(item) {
        if (this.SelectedOptions.indexOf(item.value) > -1) {
            this.SelectedOptions.splice(this.SelectedOptions.indexOf(item.value), 1);
        } else {
            this.SelectedOptions.push(item.value);
        }

        console.log(this.SelectedOptions);

        this.onValueChanged.emit(this.SelectedOptions);
    }

}
